<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <h5 class="t-white title-h5 font-family-1">
      {{ $t("new.extra_option") }}
    </h5>
    <div
      class="extra_option_picker d-flex-column justify-start align-start gap-18"
    >
      <div class="d-flex-column justify_start align-start gap-10">
        <template v-if="[6, 9, 10].includes(getGamePack.id)">
          <label
            class="medium-m t-grey font-family-2"
            v-if="singleSelect.length > 0"
            >{{ $t("new.single_select") }}</label
          >
          <div class="d-flex-row justify-start flex-wrap">
            <div
              class="option_picker"
              v-for="singleOption in singleSelect"
              :key="singleOption"
              @click.stop="clickSingleOption(singleOption)"
              :class="[disabledOptions.includes(singleOption.id) && 'disabled']"
            >
              <RadioButton :checked="isChecked(singleOption.id)" />
              <label class="medium-l font-family-2 t-white"
                >{{ singleOption.title }}
                <span class="t-blue">{{
                  renderPrice(singleOption)
                }}</span></label
              >
            </div>
          </div>
        </template>
        <label
          class="medium-m t-grey font-family-2"
          v-if="multiSelect.length > 0"
          >{{ $t("new.multi_select") }}</label
        >
        <div class="d-flex-row justify-start flex-wrap">
          <div
            class="option_picker"
            v-for="multiOption in multiSelect"
            :key="multiOption"
            @click.stop="
              clickOption(multiOption.title, multiOption.id, multiOption)
            "
          >
            <Checkbox
              variant="secondary"
              type="extra_option"
              :is-checked="isChecked(multiOption.id)"
              :emit-function="clickOption"
              :selectable-value="multiOption.id"
              :emit-function-key="multiOption.title"
            />
            <label class="medium-l font-family-2 t-white"
              >{{ multiOption.title }}
              <span class="t-blue">{{ renderPrice(multiOption) }}</span></label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from "../../../custom/RadioButton.vue";
import Checkbox from "../../../custom/Checkbox.vue";
export default {
  data() {
    return {};
  },
  components: {
    RadioButton,
    Checkbox,
  },
  computed: {
    singleSelect() {
      if (this.getGamePack?.pack_options) {
        if (this.getGamePack?.slug === "wow-solo-shuffle-boost") {
          return this.getGamePack?.pack_options?.filter(
            (option) =>
              option.multi_select !== 1 && option.const_title !== "selfplay"
          );
        }
        return this.getGamePack?.pack_options?.filter(
          (option) => option.multi_select !== 1
        );
      }
      return [];
    },
    multiSelect() {
      if (this.getGamePack?.pack_options) {
        return this.getGamePack?.pack_options?.filter(
          (option) => option.multi_select === 1
        );
      }
      return [];
    },
  },
  methods: {
    renderPrice(packOption) {
      if (packOption.type === "free") {
        return packOption.type;
      } else if (packOption.type === "variable") {
        return `+${packOption.price}%`;
      } else if (packOption.type === "fixed") {
        return `+${packOption.price}$`;
      } else {
        return `+${packOption.price}`;
      }
    },

    clickOption(key, optionId, option) {
      if (this.checkoutStore.getPackOptions?.includes(optionId)) {
        this.checkoutStore.removePackOption({
          optionIds: [optionId],
        });
        return true;
      }
      this.checkoutStore.removePackOption({
        optionIds: [optionId],
      });
      this.checkoutStore.setPackOptions({
        options: [...this.checkoutStore.getPackOptions, optionId],
      });
    },
    clickSingleOption(option) {
      if (!this.isChecked(option.id)) {
        this.checkoutStore.removePackOption({
          optionIds: option?.rules?.disable || [],
        });

        this.checkoutStore.setPackOptions({
          options: [...this.checkoutStore.getPackOptions, option.id],
        });
      } else {
        const otherOptions = this.checkoutStore.getPackOptions.filter(
          (packOpt) => packOpt !== option.id
        );
        this.checkoutStore.setPackOptions({
          options: [...otherOptions],
        });
      }
    },
    isChecked(optionId) {
      if (this.checkoutStore.getPackOptions?.includes(optionId)) {
        return true;
      }
      return false;
    },
  },
  props: {
    disabledOptions: {
      default: [],
    },
  },
  setup() {
    const { getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGamePack,
      checkoutStore,
    };
  },
};
</script>
